import { cn } from "@/lib/utils";

/**
 * The one content shell every homepage section uses.
 *
 * Matches the design's `.wrap`: max-width 1140, 28px gutters, 20px below 560.
 * Every section renders exactly one of these, which is what keeps a single text
 * left edge per breakpoint. The data attribute is what the alignment test
 * measures, so the shell can be restyled without silently unhooking the test.
 */
export function HomeWrap({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div data-home-wrap className={cn("mx-auto w-full max-w-[1140px] px-7 max-[560px]:px-5", className)}>
      {children}
    </div>
  );
}
